<template>
	<edit></edit>
</template>

<script>
	import edit from './coupon_edit.vue'
	
	export default {
		name: 'coupon_add',
		
		components: {
			edit
		}
	}
</script>